<template>
  <SvoiMaskedInput v-bind="$attrs" />
</template>

<script lang="ts" setup>
  import { SvoiMaskedInput } from '@svoi-ui/components/input'
</script>
